// Single shared AudioContext for every live-room alert sound (chat chirp,
// gift signatures). Publishers (host / co-host) are put in "broadcasting"
// mode: alerts become silent no-ops and the context is torn down so no
// WebAudio graph runs beside the live microphone (iOS WebKit renegotiates
// the audio unit when WebAudio starts → crackle in the mic capture).
let ctx = null;
let broadcasting = false;

export function isBroadcasting() {
  return broadcasting;
}

export function setBroadcasting(on) {
  broadcasting = !!on;
  if (broadcasting) closeAlertAudioContext();
}

export function getAlertAudioContext() {
  if (broadcasting || typeof window === "undefined") return null;
  if (ctx && ctx.state !== "closed") return ctx;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  try { ctx = new AC(); } catch { ctx = null; }
  return ctx;
}

export function closeAlertAudioContext() {
  const c = ctx;
  ctx = null;
  if (!c) return;
  try { c.close().catch(() => {}); } catch { /* already closed */ }
}

export function playTone({ freq, duration = 0.18, type = "sine", gain = 0.08, delay = 0 }) {
  const ac = getAlertAudioContext();
  if (!ac) return false;
  if (ac.state === "suspended") { try { ac.resume().catch(() => {}); } catch { /* noop */ } }
  const t0 = ac.currentTime + delay;
  const osc = ac.createOscillator();
  const g = ac.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t0);
  g.gain.setValueAtTime(0.0001, t0);
  g.gain.exponentialRampToValueAtTime(gain, t0 + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + duration);
  osc.connect(g).connect(ac.destination);
  osc.start(t0);
  osc.stop(t0 + duration + 0.02);
  return true;
}
